module.exports = __webpack_public_path__ + "static/img/orange-cream-m.48da43a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/orange-cream-m.jpg
// module id = w7JI
// module chunks = 0